import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['displayedValue'];

  update(event) {
    this.displayedValueTarget.textContent = event.target.value;
  }
}
